import { Component, OnInit } from '@angular/core';
import { CrudSaveComponent } from '../_directives';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService, CancelReasonCategoryService, UserService } from '../_services';
import { FormBuilder, Validators } from '@angular/forms';
import { ReasonCategory, User } from '../_models';
import { takeUntil } from 'rxjs/operators';

@Component({
  moduleId: module.id.toString(),
  selector: 'reason-category-new',
  templateUrl: './reason-category-edit.component.html'
})
export class ReasonCategoryNewComponent extends CrudSaveComponent implements OnInit {
  public reasonCategory: ReasonCategory = null;
  public currentUser: User;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected cancelReasonCategoriesService: CancelReasonCategoryService,
    protected userService: UserService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder
  ) {
    super(router, location, route, cancelReasonCategoriesService, alertService);
    this.isNew = true;
    this.objectName = 'Reason Category';
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      name: [null, [Validators.required]],
      is_global: [false]
    });
    super.ngOnInit();

    this.userService.getCurrent()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (user: User) => {
          this.currentUser = user;
        },
        error => {
          this.handleError(error);
        }
      );
  }

  protected onSaveComplete(data) {
    this.loading = false;
    this.goBack();
  }
}
